export const parseCustomerText = (text) => {
    const result = {};

    const patterns = {
        noMember: /(?:nomor|no)\s*member\s*(?:customer)?\s*:\s*(.+)/i,
        nama: /nama\s*customer\s*:\s*(.+)/i,
        alamat: /alamat\s*customer\s*:\s*(.+)/i,
        noTelepon: /nomor\s*telepon\s*customer\s*:\s*(.+)/i,
        email: /email\s*customer\s*:\s*(.+)/i,
    };

    Object.keys(patterns).forEach((key) => {
        const match = text.match(patterns[key]);
        if (match && match[1]) {
            result[key] = match[1].trim();
        }
    });

    return result;
};